import { AppOptions } from '../utils/AppOptions'

export const useServiceType = () => {
  return AppOptions.USE_HELLOBOT ? 'hb' : 'sp'
}
